import React, { FC, useEffect } from "react";
import Modal from "react-modal";
import { Booking } from "../Booking";
import { ErrorBoundary } from "../ErrorBoundary/ErrorBoundary";
import { CloseButton } from "../CloseButton/CloseButton";
import { useLabels } from "../Hooks/useLabels";
import { ModalThemeColor } from "../../../../Model/ModalThemeColor.csharp";
import classNames from "classnames";
import { OptimizelyExperimentation } from "../../BookingButton/OptimizelyExperimentation.csharp";

export type BookingModalProps = {
  isOpen: boolean;
  closeModal: () => void;
  disableBooking: boolean;
  modalThemeColor: ModalThemeColor;
  showCloseButton?: boolean;
  autostartBooking: boolean;
  ignorePersistedData?: boolean;
};

export const BookingModal: FC<BookingModalProps> = ({
  isOpen,
  closeModal,
  disableBooking,
  modalThemeColor,
  showCloseButton,
  autostartBooking,
  ignorePersistedData,
}) => {
  useEffect(() => {
    Modal.setAppElement("body");
  }, []);

  const { bookingLabels } = useLabels();
  const isVolvat = modalThemeColor == ModalThemeColor.Volvat;
  const isNimi = modalThemeColor == ModalThemeColor.Nimi;

  const errorLabel =
    bookingLabels?.commonLabels.globalBookingError ||
    "Sorry, something goes wrong. Please try again later.";

  return (
    <Modal
      isOpen={isOpen}
      className={classNames("react-modal__content", {
        "theme-blue-medium": isVolvat,
        "theme-inherit-medium": isNimi,
      })}
      ariaHideApp={false}
      overlayClassName="react-modal__overlay"
      bodyOpenClassName="react-modal__open"
    >
      {isOpen && (
        <div className="container-fluid">
          <div className="page-boundary page-boundary--booking-outer">
            {showCloseButton && (
              <CloseButton
                buttonLabel={bookingLabels?.commonLabels.closeButtonLabel}
                onClick={closeModal}
              />
            )}
            {disableBooking ? (
              <div
                className="error-boundary"
                dangerouslySetInnerHTML={{
                  __html: errorLabel,
                }}
              />
            ) : (
              <ErrorBoundary message={errorLabel}>
                <Booking
                  showCloseButton={showCloseButton}
                  closeModal={closeModal}
                  autostartBooking={autostartBooking}
                  ignorePersistedData={ignorePersistedData}
                />
              </ErrorBoundary>
            )}
          </div>
        </div>
      )}
    </Modal>
  );
};
